<template>
  <div>
    <div class="ValidatorBetail">
      <div class="ValidatorBetail-W">
        <div class="Homeinput"></div>
        <div class="BkHeight_conent">
          <div class="BkHeight_conent_header">
            <p>
              <span>NFT Details</span>
            </p>
          </div>
          <div class="BkHeight_conent_Ul">
            <div class="bk_img">
              <img :src="image" />
            </div>
            <ul>
              <li>
                <p>{{ itemName }}{{ tokenId }}</p>
              </li>
              <li>
                <p>Collection :</p>
                <p @click="contract(contractAddress)">{{ contractName }}</p>
              </li>
              <li>
                <p>TokenID :</p>
                <p style="color: #8d8d8d">{{ tokenId }}</p>
              </li>
              <li>
                <p>Contract :</p>
                <p @click="contract(contractAddress)">{{ contractAddress }}</p>
              </li>
              <li>
                <p>Owner :</p>
                <p @click="AdderssTo(owner)">{{ owner }}</p>
              </li>
              <li>
                <p>Creator :</p>
                <p @click="AdderssTo(creator)">{{ creator }}</p>
              </li>
              <!-- <li>
                <p>Assets :</p>
                <p>
                  {{ image }}
                </p>
              </li> -->
            </ul>
          </div>
        </div>
        <div>
          <div class="Blocks">
            <div class="Block_Top">
              <span>Item Activity</span>

              <!-- <div class="search">
          <input type="text" placeholder="Search for Token Name" />
          <img src="../../../assets/pc/Index/seach.png" />
        </div> -->
            </div>
            <div v-show="executeiList.length > 0">
              <div class="Block_list">
                <ul class="block_list_Top">
                  <li>Hash</li>
                  <li>Type</li>
                  <li>Age</li>
                  <li>From</li>
                  <li>To</li>
                  <li>TokenID</li>
                </ul>
              </div>
              <div class="Block_List_center notranslate">
                <ul>
                  <!-- <li v-for="(item, index) in executeiList" :key="index"> -->
                  <li v-for="(item, index) in executeiList" :key="index">
                    <p
                      @click="Tash(index)"
                      style="color: #fff; cursor: pointer"
                    >
                      {{ item.txHash }}
                    </p>
                    <p>
                      {{ item.functions }}
                    </p>
                    <p>
                      <span>{{ item.tradeTime }}</span>
                    </p>
                    <p @click="AdderssTo(item.fromEvmAddress1)">
                      {{ item.fromEvmAddress }}
                    </p>
                    <p @click="AdderssTo(item.toEvmAddress1)">
                      {{ item.toEvmAddress }}
                    </p>
                    <p>{{ item.tokenAmount }}</p>
                  </li>
                </ul>
              </div>
              <div  :class="executeiList.length>10?'Block_List_Bottom':''">
                <el-pagination
                  :current-page.sync="pageNum"
                  background
                  :page-size="20"
                  layout="prev, pager,
      next"
                  @current-change="CurrentChange"
                  :total="total"
                >
                </el-pagination>
              </div>
            </div>
            <div v-show="executeiList.length <= 0">
              <EmptyState />
            </div>
          </div>
          <!-- <TokensList :executeiList="executeiList"></TokensList> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { NftItemDetail } from "@/assets/server/api";
// import Listbox from "@/components/pc/Listbox.vue";
// import Homseach from "@/components/pc/serch.vue";
// import Homeinput from "../Home/Home_input.vue";
// import TokensList from "./ActivityList.vue";
import EmptyState from "../EmptyState/EmptyState.vue";
import { getSubStr, formatSeconds } from "../../../utils/utils";
export default {
  data() {
    return {
      contractAddress: "",
      tokenId: "",
      list1: [],
      owner: "",
      image: "",
      itemName: "",
      creator: "",
      tokenId: "",
      count: "",
      contractAddress: "",
      executeiList: [],
      pageNum: 1,
      total: null,
      contractName: "",
      imgurlnft: require("@/assets/pc/Index/nft.png"),
    };
  },
  components: {
    // Homeinput,
    // Homseach,
    // Listbox,
    // TokensList,
    EmptyState,
  },
  mounted() {
    // this.initCharts();
    this.getContractTxLists();
  },
  watch: {
    $route: {
      handler: function (to, form) {
        if (to.path === "/pc/NFTslistdetail") {
          this.contractAddress = to.query.contractAddress;
          this.tokenId = to.query.tokenId;
          // console.log(this.tokenId);

          // console.log(this.contractAddress);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    Tash(index) {
      let params = {
        txHash: this.executeiList[index].txHash1,
        type: 8,
        standard: this.executeiList[index].standard,
      };
    //  console.log(params);
      this.$router.push({ path: "/pc/To", query: params });
    },
    async getContractTxLists() {
      let formData = new FormData();
      let params = {
        tokenId: this.tokenId,
        contractAddress: this.contractAddress,
        pageNum: this.pageNum,
        pageSize: 20,
      };
      let item = params;

      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await NftItemDetail(formData);
   //   console.log(res);

      this.owner = res.result.owner;
      this.image = res.result.image;
      if(res.result.image==''|| res.result.image==null){
        this.image=this.imgurlnft;
      }else{
        this.image = res.result.image;
      }
      this.itemName = res.result.itemName;
      if( res.result.contractName !==null){
      this.contractName = res.result.contractName;
      }else{
        this.contractName=getSubStr(res.result.contractAddress,0,3);
      }
      this.creator = res.result.creator;
      this.tokenId = res.result.tokenId;
      this.count = res.result.count;
      this.total = Number(res.result.count);
   //   console.log(this.total);
      this.contractAddress = res.result.contractAddress;
      this.executeiList = res.result.executeList;
   //   console.log(this.executeiList);
      var calctime = new Date();
      let strdate = Math.floor(calctime.getTime() / 1000);
      for (var i = 0; i < this.executeiList.length; i++) {
        this.executeiList[i].txHash1 = this.executeiList[i].txHash;
        this.executeiList[i].txHash = getSubStr(
          this.executeiList[i].txHash,
          0,
          6
        );
        this.executeiList[i].fromEvmAddress1 =
          this.executeiList[i].fromEvmAddress;
        this.executeiList[i].fromEvmAddress = getSubStr(
          this.executeiList[i].fromEvmAddress,
          0,
          6
        );
        this.executeiList[i].toEvmAddress1 = this.executeiList[i].toEvmAddress;
        this.executeiList[i].toEvmAddress = getSubStr(
          this.executeiList[i].toEvmAddress,
          0,
          6
        );
        let timestamp = Math.floor(this.executeiList[i].tradeTime / 1000);
        var s = strdate - timestamp;
        if (s <= 0) {
          s = 1;
        }
        this.executeiList[i].tokenAmount =
          this.executeiList[i].tokenAmount.split(",")[0];
        this.executeiList[i].tradeTime = formatSeconds(s);
      }

      // var calctime = new Date();
      //let strdate = Math.floor(calctimea.getTime() / 1000);
      // let strdate = Math.floor(calctime.getTime() / 1000);
      // this.list1 = res.result.list;
      // console.log(this.list1);
      // for (var i = 0; i < this.list1.length; i++) {

      //   this.list1[i].txHash1 = getSubStr(this.list1[i].txHash, 0, 6);
      //   this.list1[i].toEvmAddress1 = getSubStr(this.list1[i].toEvmAddress,0,6);
      //   this.list1[i].fromEvmAddress1 = getSubStr(this.list1[i].fromEvmAddress,0,6);
      //   // this.list1=getSubStr(this.list1[i].txHash,0,6);
      //   let timestamp = Math.floor(
      //       this.gltime(this.list1[i].tradeTime) / 1000
      //     );
      //     var s = strdate - timestamp;
      //     if (s <= 0) {
      //       s = 1;
      //     }
      //     this.list1[i].tradeTime = formatSeconds(s);
      //     //this.list1[i].type = listTypea(this.list1[i].type);
      // }
    },
    contract(index) {
      let params = {
        contractAddress: index,
      };
      this.$router.push({ path: "/pc/NFTsdetail", query: params });
    },
    AdderssTo(index) {
     // console.log(index);
      this.$router.push({ path: "/pc/BkHash", query: { query: index } });
    },
    CurrentChange(val) {
      this.pageNum = val;
      this.getContractTxLists();
      //  this.blockList();
    },
  },
};
</script>

<style lang="less" scoped>
.ValidatorBetail {
  width: 100%;
  background: #13161b;
  .ValidatorBetail-W {
    width: 1160px;
    margin: 0 auto;
    background: #13161b;
    .Homeinput {
      padding: 10px 0;
    }
    .BkHeight_conent {
      background: #0b0c0f;
      border-radius: 16px 16px 16px 16px;
      padding: 20px 20px 0 20px;
      margin-bottom: 20px;
      .BkHeight_conent_header {
        p {
          span:nth-child(1) {
            font-size: 18px;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #ffffff;
            line-height: 24px;
            -webkit-background-clip: text;
            margin-left: 40px;
            margin-top: 40px;
          }
        }
      }

      .BkHeight_conent_Ul {
        margin-left: 40px;
        display: flex;
        padding-bottom: 40px;
        .bk_img {
          margin-top: 30px;
          width: 356px;
          // height: 338px;
          height: 318px;
          height: 318px;
          background: #13161b;
          border-radius: 18px 18px 18px 18px;
          opacity: 1;
          margin-right: 71px;
          img {
            // width: 356px;
            // height: 318px;
            width: 100%;
            
            border-radius: 6px;
            object-fit: cover;
          }
        }
        ul {
          li {
            display: flex;
            height: 50px;
            margin-top: 12px;
            p:nth-child(1) {
              //  flex: 0 0 10%;
              font-size: 14px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #898b8d;
              line-height: 40px;
              // width: 80px;
            }
            p:nth-child(2) {
              // border: 1px solid red;
              // flex: 0 0 90%;
              margin-left: 20px;
              font-size: 14px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #fff;
              line-height: 40px;
              cursor: pointer;
              // width: 539px;
              -webkit-background-clip: text;
              img {
                width: 26px;
                height: 26px;
                margin-top: 20px;
              }
              span {
                // display: block;
                // border: 1px solid red;
              }
            }
          }
          li:nth-child(2) {
            p {
              img {
                width: 24px;
                height: 40px;
                margin-left: 20px;
                cursor: pointer;
              }
            }
          }
          li:nth-child(7) {
            width: 500px;
            overflow: hidden; //超出的文本隐藏
            text-overflow: ellipsis; //溢出用省略号显示
            white-space: nowrap; // 默认不换行；

            p:nth-child(2) {
              width: 500px;
              overflow: hidden; //超出的文本隐藏
              text-overflow: ellipsis; //溢出用省略号显示
              white-space: nowrap; // 默认不换行；

              margin-left: 6px;
              line-height: 40px !important;
            }
          }
        }
      }
    }
    .TopValidatorsList {
      padding-bottom: 40px;
    }
  }
}
.BlockList {
  width: 100%;
  background: #13161b;
  .BlockList-W {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 36px;
    background: #13161b;
    .BlockList_Inp {
      padding: 40px 0;
    }
    .Blockbox {
      margin-bottom: 20px;
      display: flex;
      .box1 {
        width: 295px !important;
      }
      .box2 {
        width: 476px !important;
      }
      .box3 {
        width: 349px !important;
      }
      .Blockboxli {
        width: 373px;
        height: 120px;
        background: #0b0c0f;
        border-radius: 6px 6px 6px 6px;
        opacity: 1;
        margin-right: 20px;
        .Blocktit {
          font-size: 12px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.5);
          line-height: 17px;
          margin-top: 30px;
          margin-left: 40px;
        }
        .Blockcon {
          height: 35px;
          font-size: 24px;
          font-family: Source Han Sans CN-Medium, Source Han Sans CN;
          font-weight: 500;
          color: #00e79a;
          line-height: 35px;
          margin-top: 8px;
          margin-left: 40px;
        }
      }
    }
  }
}
</style>
<style lang="less" scoped>
.Blocks {
  // height: 1500px;
  padding: 36px 20px;
  background: #0b0c0f;
  width: 1160px;
  border-radius: 16px 16px 16px 16px;
  .Block_Top {
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;
    .total {
      display: inline-block;
      font-size: 14px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #898b8d;
      margin-left: 30px;
      line-height: 24px !important;
    }
    .search {
      width: 380px;
      height: 40px;
      background: #18191e;
      border-radius: 6px 6px 6px 6px;
      opacity: 1;
      margin-left: 356px;
      display: flex;
      justify-content: space-between;
      input {
        height: 40px;
        border: none;
        margin-left: 20px;
      }
      img {
        width: 21px;
        height: 21px;
        margin-top: 12px;
        margin-right: 20px;
      }
    }
    span:nth-child(1) {
      font-size: 18px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #ffffff;
      line-height: 24px;
      -webkit-background-clip: text;
      margin-left: 20px;
    }
  }
  .Block_list {
    .block_list_Top {
      display: flex;
      width: 1120px;
      height: 60px;
      background: #14151a;
      border-radius: 10px 10px 10px 10px;
      opacity: 1;
      padding: 0 20px;
      li {
        font-size: 16px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898b8d;
        line-height: 62px;
        -webkit-background-clip: text;
      }
      li:nth-child(1) {
        flex: 0 0 15%;
      }
      li:nth-child(2) {
        flex: 0 0 20%;
      }
      li:nth-child(3) {
        flex: 0 0 22%;
      }
      li:nth-child(4) {
        flex: 0 0 20%;
      }
      li:nth-child(5) {
        flex: 0 0 15%;
      }
      li:nth-child(6) {
        flex: 0 0 8%;
      }
    }
  }
  .Block_List_center {
    ul {
      height: 620px;
      padding: 0 20px;
      li {
        display: flex;
        height: 62px;
        border-bottom: 1px solid #22252e;
        line-height: 62px;
        p {
          font-size: 14px;
          font-family: SF Pro Text-Regular, SF Pro Text;
          font-weight: 400;
          -webkit-background-clip: text;
        }
      }
      li:nth-child(10) {
        //  border: none;
      }
      p:nth-child(1) {
        flex: 0 0 15%;
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898b8d;
      }
      p:nth-child(2) {
        flex: 0 0 20%;
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898b8d;
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        display: flex;
        // border: 1px solid red;
        img {
          width: 34px;
          height: 34px;
          background: #22252e;
          border-radius: 172px 172px 172px 172px;
          opacity: 1;
          margin-top: 16px;
          margin-right: 5px;
        }
        span {
          display: inline-block;
          // width: 280px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
          margin-left: 8px;
        }
      }
      p:nth-child(3) {
        flex: 0 0 22%;
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898b8d;
        position: relative;
        cursor: default;
        .Hover1 {
          display: none;
          .Hover {
            padding: 3px 10px;
            display: inline-block;
            line-height: 20px;
            position: absolute;
            top: -10px;
            left: 0px;
            background-color: #3c485c;
            border-radius: 5px;
            i {
              position: absolute;
              top: 18px;
              left: 40%;
              transform: rotate(180deg);
              color: #3c485c;
            }
          }
        }
      }
      p:nth-child(2):hover {
        .Hover1 {
          display: block !important;
        }
      }
      p:nth-child(4) {
        flex: 0 0 20%;
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #fff;
        cursor: pointer;
        span {
          display: inline-block;
          width: 280px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
        }
      }
      p:nth-child(5) {
        flex: 0 0 15%;
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #fff;
        cursor: pointer;
      }
      p:nth-child(6) {
        flex: 0 0 8%;
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898b8d;
      }
    }
  }
  .Block_List_Bottom {
    margin-top: 650px;
  }
}

.el-pagination {
  display: flex;
  justify-content: right;
  ::v-deep button {
    min-width: 24px !important;
    height: 24px !important;
    font-size: 12px;
    color: #fff !important;
    background: none !important;
    // background: #3c485c !important;
    border-radius: 4px 4px 4px 4px !important;
  }
  ::v-deep ul {
    li {
      min-width: 24px !important;
      height: 24px !important;
      background: none !important;
      //border-radius: 4px 4px 4px 4px !important;
      font-size: 12px;
      font-family: aaa;
      font-weight: 400 !important;
      color: #ffffff !important;
      line-height: 20px !important;
      margin: 0 4px !important;
      padding: 2px 8px !important;
    }
    .active {
      background: #22252e !important;
    }
    .more::before {
      line-height: 20px !important;
    }
  }
}
</style>
